jQuery(function ($) {
	function addPaymentFormSpinner() {
		return (
			'<div class="spinner-1-container">' +
			'<div class="spinner-1">' +
			'<div class="double-bounce1"></div>' +
			'<div class="double-bounce2"></div>' +
			'</div>' +
			'</div>'
		);
	}

	$('ul.charity-campaigns li a.button').on('click', function (e) {
		e.preventDefault();

		const element = $(this).closest('li.product');
		const amount = element.find('input[name="amount"]').maskMoney('unmasked')[0];
		const data = element.data();

		const loadingContent = jQuery(addPaymentFormSpinner());
		jQuery('body').append(loadingContent);

		const formData = new FormData();
		formData.append('campaignID', data.id);
		formData.append('amount', data.fixed ? data.minamount : amount);
		formData.append('action', 'add_to_cart_form');
		formData.append('_ajax_nonce', data.securenoncename);

		$.ajax({
			url: data.adminurl,
			type: 'post',
			data: formData,
			contentType: false,
			processData: false,
			cache: false,
			dataType: 'json',
			success: function (response) {
				// jQuery('#threedsContent').html(response.htmlContent);
				// tb_remove();
				// loadingContent.remove();
				window.location.href = data.checkoutPage;
				loadingContent.remove();
			},
			error: function (err) {
				loadingContent.remove();
				alert(err.responseJSON.message);
			},
		});
	});

	$(
		'form[name="payment-form"] .donation-checkout-section div.donation-remove a.remove'
	).on('click', function (e) {
		e.preventDefault();

		const data = $(this).data();
		const loadingContent = jQuery(addPaymentFormSpinner());
		jQuery('body').append(loadingContent);

		const formData = new FormData();
		formData.append('remove', data.index);
		formData.append('action', 'remove_cart_form');
		formData.append('_ajax_nonce', data.securenoncename);

		$.ajax({
			url: data.adminurl,
			type: 'post',
			data: formData,
			contentType: false,
			processData: false,
			cache: false,
			dataType: 'json',
			success: function (response) {
				location.reload();
			},
			error: function (err) {
				loadingContent.remove();
				alert(err.responseJSON.message);
			},
		});
	});

	$('form[name="payment-form"]').on('submit', function (e) {
		e.preventDefault();

		const adminUrl = $(this).attr('action');

		const loadingContent = jQuery(addPaymentFormSpinner());
		jQuery('body').append(loadingContent);
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});

		const formData = jQuery(this).serializeArray();

		jQuery.ajax({
			url: adminUrl,
			type: 'post',
			data: formData,
			dataType: 'json',
			success: function (response) {
				jQuery('#threedsContent').html(response.htmlContent);
				// tb_remove();
				loadingContent.remove();
			},
			error: function (err) {
				loadingContent.remove();
				jQuery('#error-container')
					.find('.ab-message')
					.html(err.responseJSON.message);
				jQuery('#error-container').show();
			},
		});

		return false;
	});
});
